<template>
  <div class="head-icon" width="60px">
    <div class="head-main">
      <div class="main-top">
        <el-tooltip
          class="item"
          effect="dark"
          content="开始"
          placement="right"
        >
          <img
            :class="['head-icon-img', { active: activeIcon === 'start' }]"
            src="@/assets/logo-icon.png"
            @click="handleIconClick('start')"
          />
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          content="项目管理"
          placement="right"
        >
          <img
            :class="[
              'head-icon-img-search',
              { active: activeIcon === 'cases' },
            ]"
            :src="activeIcon === 'cases' ? search7 : cases"
            @click="handleIconClick('cases')"
          />
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          content="缺陷管理"
          placement="right"
        >
          <img
            :class="['head-icon-img-search', { active: activeIcon === 'bugs' }]"
            :src="activeIcon === 'bugs' ? search8 : search2"
            @click="handleIconClick('bugs')"
          />
        </el-tooltip>
      </div>

      <div class="main-bottom">
        <el-tooltip
          class="item"
          effect="dark"
          content="智能引擎"
          placement="right"
        >
          <img
            :class="['head-icon-img-search', { active: activeIcon === 'AI' }]"
            :src="activeIcon === 'AI' ? search10 : search9"
            @click="handleIconClick('AI')"
          />
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          content="帮助和反馈"
          placement="right"
          v-if="myData.isProjectAdmin"
        >
          <img
            :class="[
              'head-icon-img-search',
              { active: activeIcon === 'workOrder' },
            ]"
            :src="activeIcon === 'workOrder' ? search12 : search13"
            @click="handleIconClick('workOrder')"
          />
        </el-tooltip>

        <el-tooltip
          class="item"
          effect="dark"
          content="管理员设置"
          placement="right"
          v-if="myData.isProjectAdmin"
        >
          <img
            :class="[
              'head-icon-img-search-setting',
              { active: activeIcon === 'settings' },
            ]"
            @click="handleIconClick('settings')"
            :src="activeIcon === 'settings' ? search5 : search11"
          />
        </el-tooltip>

        <div class="head-icon-img-user">
          <el-popover placement="right" width="242" trigger="click">
            <div class="user-popover-content">
              <div class="user-header">
                <div class="avatar" @click="handleAvatarClick">
                  <img
                    :src="'http://175.24.182.107:8080/' + userInfo.pic"
                    alt="Avatar"
                    v-if="userInfo.pic"
                  />
                  <span v-else style="font-size: 10px">{{
                    userInfo.username
                  }}</span>
                  <input
                    ref="fileInput"
                    type="file"
                    accept="image/png, image/jpeg"
                    style="display: none"
                    @change="handleAvatarUpload"
                  />
                </div>
                <div class="user-info">
                  <div
                    class="user-name field-display"
                    v-if="!editableFields.username"
                    @click="toggleEdit('username')"
                  >
                    {{ userInfo.username }}
                  </div>
                  <el-input
                    v-else
                    ref="usernameInput"
                    v-model="modalForms.username"
                    @blur="() => handleFieldBlur('username')"
                    placeholder="请输入"
                  ></el-input>
                  <div
                    class="user-email field-display"
                    v-if="!editableFields.email"
                    @click="toggleEdit('email')"
                  >
                    {{ userInfo.email }}
                  </div>
                  <el-input
                    v-else
                    ref="emailInput"
                    v-model="modalForms.email"
                    @blur="() => handleFieldBlur('email')"
                    placeholder="请输入"
                  ></el-input>
                </div>
              </div>
              <div class="user-details">
                <div class="detail-item">
                  <span class="detail-label">公司</span>
                  <span class="value" @click="toggleEdit('company_name')">{{
                    userInfo.company_name
                  }}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">角色</span>
                  <span
                    class="value field-display"
                    v-if="!editableFields.role_name"
                    @click="toggleEdit('role_name')"
                    >{{ userInfo.role_name }}</span
                  >
                  <el-select
                    v-else
                    v-model="modalForms.role_id"
                    placeholder="请选择"
                    @change="() => handleSelectChange('role_name')"
                  >
                    <el-option
                      v-for="item in roles"
                      :key="item.id"
                      :label="item.role_name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>

              <div class="change-actions">
                <div class="user-actions" @click="handleChangeCompany" style="cursor: pointer;">
                  <button class="logout-btn">
                    <img
                      src="@/assets/login-change.png"
                      alt=""
                      style="margin-top: 5px"
                    />
                    切换公司
                  </button>
                </div>

                <div class="user-actions" @click="handleChangeSettings"  style="cursor: pointer;">
                  <button class="logout-btn">
                    <img
                      src="@/assets/header-edit.png"
                      alt=""
                      style="margin-top: 5px"
                    />
                    个人设置
                  </button>
                </div>

                <div class="user-actions" @click="handleLogout"  style="cursor: pointer;">
                  <button class="logout-btn">
                    <img
                      src="@/assets/login-out.png"
                      alt=""
                      style="margin-top: 5px"
                    />
                    退出登录
                  </button>
                </div>
              </div>
            </div>
            <div
              class="user-icon"
              slot="reference"
              style="display: inline-block; cursor: pointer"
            >
              <img
                v-if="userInfo.pic"
                :src="'http://175.24.182.107:8080/' + userInfo.pic"
                alt="Avatar"
                style="
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 50%;
                "
              />
              <span v-else style="padding: 10px">{{
                userInfo.username ? userInfo.username.slice(-2) : ""
              }}</span>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import img1 from "@/assets/search.png";
import img2 from "@/assets/bug.png";
import img3 from "@/assets/search3.png";
import img4 from "@/assets/search4.png";
import img5 from "@/assets/head-settings.png";
import img6 from "@/assets/cases.png";
import img7 from "@/assets/head-project.png";
import img8 from "@/assets/head-bug.png";
import img9 from "@/assets/head-unai.png";
import img10 from "@/assets/head-ai.png";
import img11 from "@/assets/head-unsetting.png";
import img12 from "@/assets/feedBack-select.png";
import img13 from "@/assets/feedBack-unselect.png";
import { auth } from "@/api/request";
import tokenManager from "../util/token";

export default {
  name: "HeadTitle",
  data() {
    return {
      search: img1,
      search2: img2,
      search3: img3,
      search4: img4,
      search5: img5,
      cases: img6,
      search7: img7,
      search8: img8,
      search9: img9,
      search10: img10,
      search11: img11,
      search12: img12,
      search13: img13,

      activeIcon: "cases",
      loginInfo: {},
      userInfo: {},
      editableFields: {
        company_name: false,
        email: false,
        role_name: false,
        username: false,
      },
      username: "",
      modalForms: {
        company_name: "",
        email: "",
        role_name: "",
        username: "",
        role_id: "",
      },
      roles: [{ id: "-3", role_name: "只读" }],
      myData: {},
    };
  },
  created() {
    this.loadUserInfo();
    this.roleOptions();

    this.loginInfo = JSON.parse(localStorage.getItem("LoginInfo"));
    this.setActiveIconByRoute(this.$route.path);

    this.myData = JSON.parse(localStorage.getItem("myData")) || {};

    if (!this.activeIcon) {
      this.activeIcon = "cases";
    }
  },
  methods: {
    gotoDashboard() {
      if (this.$route.path !== "/dashboard") {
        this.$router.push("/dashboard");
      }
    },
    gotoStart() {
      if (this.$route.path !== "/start") {
        this.$router.push("/start");
      }
    },
    gotoSettings() {
      // 进入管理员设置默认打开「概括」
      if (this.$route.path !== "/setting/settingOverView") {
        this.$router.push("/setting/settingOverView");
      }
    },
    gotoBugs() {
      if (this.$route.path !== "/bug/BugOverView/") {
        this.$router.push("/bug/BugOverView/");
      }
    },

    gotoAI() {
      if (this.$route.path !== "/aiCaseOverview") {
        this.$router.push("/aiCaseOverview");
      }
    },

    gotoWorkOrder() {
      if (this.$route.path !== "/workOrderOverview") {
        this.$router.push("/workOrderOverview");
      }
    },

    setActiveIconByRoute(path) {
      if (path.startsWith("/start")) {
        this.activeIcon = "start";
      } else if (path.startsWith("/bug")) {
        this.activeIcon = "bugs";
      } else if (path.startsWith("/cases")) {
        this.activeIcon = "cases";
      } else if (path.startsWith("/setting")) {
        this.activeIcon = "settings";
      } else if (path.startsWith("/ai")) {
        this.activeIcon = "AI";
      } else if (path.startsWith("/personal")) {
        this.activeIcon = "personal";
      } else if (path.startsWith("/workOrder")) {
        this.activeIcon = "workOrder";
      } else {
        this.activeIcon = "";
      }
    },
    handleIconClick(iconName) {
      this.activeIcon = iconName;
      switch (iconName) {
        case "start":
          this.gotoStart();
          break;
        case "search":
          break;
        case "cases":
          this.gotoDashboard();
          break;
        case "bugs":
          this.gotoBugs();
          break;
        case "settings":
          this.gotoSettings();
          break;
        case "AI":
          this.gotoAI();
          break;
        case "workOrder":
          this.gotoWorkOrder();
          break;
      }
    },

    loadUserInfo() {
      if (!this.hasValidToken()) return;
      auth
        .getUserInfo()
        .then((res) => {
          if (res) {
            this.userInfo = res;
            localStorage.removeItem("userInfo");
            localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    hasValidToken() {
      const token = tokenManager.getToken() || this.$store.state.LoginToken || this.$store.state.loginToken || "";
      return /^Token\s+\S+/.test(String(token).trim());
    },

    // 退出登录
    handleLogout() {
      const param = {
        user_id: this.userInfo.id,
      };
      auth.logout(param).then((res) => {
        tokenManager.clearToken();
        this.$router.push("/login");
      });
    },

    toggleEdit(field, forceClose = false) {
      if (forceClose || this.editableFields[field]) {
        setTimeout(() => {
          this.$set(this.editableFields, field, false);
        }, 200);
      } else {
        // 关闭所有其他输入框
        Object.keys(this.editableFields).forEach((key) => {
          if (key !== field) {
            this.$set(this.editableFields, key, false);
          }
        });
        // 打开当前输入框
        this.$set(this.editableFields, field, true);

        this.$nextTick(() => {
          if (field === "username" && this.$refs.usernameInput) {
            this.$refs.usernameInput.focus();
          } else if (field === "email" && this.$refs.emailInput) {
            this.$refs.emailInput.focus();
          }
        });
      }
    },

    handleFieldBlur(field) {
      const fieldValue = this.modalForms[field];
      if (!fieldValue || fieldValue.trim() === "") {
        this.toggleEdit(field, true);
        return;
      }
      this.handleSelectChange(field);
    },

    handleSelectChange(field, type) {
      const fieldValue =
        field === "role_name"
          ? this.modalForms.role_id
          : this.modalForms[field];
      if (
        !fieldValue ||
        (typeof fieldValue === "string" && fieldValue.trim() === "")
      ) {
        this.toggleEdit(field, true);
        return;
      }

      this.toggleEdit(field, true);

      let param;
      if (field === "role_name") {
        param = {
          key: "role_id",
          value: this.modalForms.role_id,
          user_id: this.userInfo.id,
        };
      } else {
        param = {
          key: field,
          value: this.modalForms[field],
          user_id: this.userInfo.id,
        };
      }

      auth
        .updateUserInfo(param)
        .then(() => {
          this.loadUserInfo();
          this.$message.success("更新成功");
        })
        .catch((e) => {
          let msg = e.toString();
          if (msg.match(/^Error:/) !== null) {
            this.$message.error(msg);
          }
        });
    },

    handleAvatarClick() {
      this.$refs.fileInput.click();
    },

    handleAvatarUpload(e) {
      const file = e.target.files[0];
      if (!file) return;

      const isJPG = ["image/jpeg", "image/png"].includes(file.type);
      const isLt1M = file.size / 1024 / 1024 < 1;

      if (!isJPG) {
        this.$message.error("头像只能是 JPG / PNG 格式！");
        return;
      }
      if (!isLt1M) {
        this.$message.error("头像大小不能超过 1MB！");
        return;
      }

      if (this.userInfo.pic) {
        let param = {
          file_id: this.userInfo.pic,
        };
        auth
          .delUserHeaderPic(param)
          .then(() => {
            const formData = new FormData();
            formData.append("filebuffer", file);
            formData.append("size", file.size);
            formData.append("name", file.name);

            auth
              .userHeaderPic(formData)
              .then(() => {
                this.$message.success("更新成功");
                this.loadUserInfo();
              })
              .catch((err) => {
                this.$message.error(err.message || "上传失败");
              })
              .finally(() => {
                this.$refs.fileInput.value = "";
              });
          })
          .catch((err) => {});
      } else {
        const formData = new FormData();
        formData.append("filebuffer", file);
        formData.append("size", file.size);
        formData.append("name", file.name);

        auth
          .userHeaderPic(formData)
          .then(() => {
            this.$message.success("更新成功");
            this.loadUserInfo();
          })
          .catch((err) => {
            this.$message.error(err.message || "上传失败");
          })
          .finally(() => {
            this.$refs.fileInput.value = "";
          });
      }
    },

    handleChangeCompany() {
      this.$router.push("/selectCompany/selectCompanyView");
    },

    handleChangeSettings() {
      this.$router.push("/personalSetingView");
    },

    roleOptions() {
      if (!this.hasValidToken()) return;
      auth
        .role({})
        .then((result) => {
          this.roles = this.roles.concat(result.roles);
          localStorage.removeItem("rolesList");
          localStorage.setItem("rolesList", JSON.stringify(this.roles));
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style>
.head-main {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
}
.main-top {
  display: flex;
  flex-direction: column;
}
.head-icon {
  width: 64px;
  background-color: #2a304c;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
}
.head-icon-img {
  width: 36px;
  height: 36px;
  padding: 20%;
}
.head-icon-img.active {
  background: rgba(255, 164, 38, 0.16);
  border-radius: 8px;
}
.head-icon-img-search,
.head-icon-img-search-setting {
  width: 24px;
  height: 24px;
  padding: 28%;
  box-sizing: content-box;
}
.head-icon-img-user {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin: 17%;
  background-color: aliceblue;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #333;
  cursor: pointer;
  overflow: hidden;
}
img {
  cursor: pointer;
}
.user-icon {
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  font-weight: 800;
}

.head-icon-img-search.active,
.head-icon-img-search-setting.active {
  background-image: url("../assets/select-bg.png");
  margin-left: 15px;
  padding-left: 20% !important;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: auto;
}

.user-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.avatar {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 16px;
  background-color: #3956e6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: white;
  flex-shrink: 0;
}

.avatar img {
  background-color: #fff;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-info {
  flex: 1;
}

.user-name {
  font-size: 16px;
  font-weight: 500;
  color: #303133;
  margin: 0;
}

.user-email {
  font-size: 12px;
  color: #222;
  margin: 4px 0 0;
}

.user-details {
  margin-bottom: 20px;
  border-bottom: 1px solid #ebeef5;
}

.detail-item {
  display: flex;
  margin-bottom: 12px;
  align-items: center;
}

.detail-label {
  padding: 2px 6px;
  background-color: #3956e6;
  color: white;
  border-radius: 4px;
  font-size: 10px;
  margin-right: 8px;
}

.value {
  flex: 1;
  font-size: 14px;
  color: #303133;
}

.user-actions {
  text-align: right;
  background-color: rgba(0, 0, 0, 0.25);
  margin-bottom: 4px;
  border-radius: 4px;
}

.logout-btn {
  border: none;
  /* border-radius: 4px; */
  color: #222222;
  background-color: transparent;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.2s ease;
}

.field-display {
  border: 1px solid transparent;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.field-display:hover {
  background-color: #f5f7fa;
  border-color: #dcdfe6;
}

.change-actions {
  /* display: flex; */
  /* justify-content: space-between; */
}
</style>
